import { useQuery } from "@tanstack/react-query";
import { sdk } from "@/config/medusa";
import { handleErrorToast } from "@/utils/helpers";
import { useUser } from "@/context/user";
import storage from "@/utils/storage";
import { Forms } from "@/types/form";

const useQueryVendor = () => {
  const isAuthenticated = useUser((state) => state.isAuthenticated);
  const vid = storage.getItem("vid");

  const getVendor = async () => {
    try {
      const data = await sdk.client.fetch<Forms["Vendor"]>(`/vendor/${vid}`);
      return data;
    } catch (e) {
      handleErrorToast(e);
    }
  };

  const query = useQuery({
    queryKey: ["vendor", vid],
    queryFn: getVendor,
    enabled: isAuthenticated,
  });

  return {
    ...query,
    isFetching: query.isFetching,
  };
};

export default useQueryVendor;
